import React, {useState, useEffect} from "react";
import {
    Typography,
    Card,
    CardHeader,
    CardBody,
    Button,
    Textarea,
    Select,
    Option,
} from "@material-tailwind/react";
import InputMask from "react-input-mask";
import axios from "axios";

const RegisterDiscount = () => {
    const [discounts, setDiscounts] = useState([]);
    const [selectedDiscount, setSelectedDiscount] = useState("");
    const [parcelCode, setParcelCode] = useState("");
    const [notes, setNotes] = useState(null);
    const [error, setError] = useState(null)

    useEffect(() => {
        async function loadDiscounts() {
            try {
                const response = await fetch(`/discounts/get_special_discounts.json`);
                if (!response.ok) {
                    console.log("No se encontraron descuentos.");
                    return;
                }
                const data = await response.json();
                setDiscounts(data);
            } catch (err) {
                console.error("Error al buscar descuentos especiales activos:", err);
            }
        }

        loadDiscounts();
    }, []);

    const toggleDiscount = (e) => {
        setSelectedDiscount(e);
    }

    const handleSave = async () => {
        await axios.post(`/discount_lots.json`, {
            parcel_code: parcelCode,
            notes: notes,
            discount_id: selectedDiscount
        }, {
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(function (response) {
            window.location.href = '/discounts';
        }).catch(function (error) {
            setError(error.data);
        });
    }

    return (
        <>
            <div className="mt-12">
                <div className="mb-4 grid grid-cols-1 gap-6 xl:grid-cols-1">
                    <Card className="overflow-hidden xl:col-span-2 border border-blue-gray-100 shadow-sm">
                        <CardHeader
                            floated={false}
                            shadow={false}
                            color="transparent"
                            className="m-0 flex items-center justify-between p-6"
                        >
                            <div>
                                <Typography variant="h6" color="blue-gray" className="mb-1">
                                    Alta descuento especial
                                </Typography>
                            </div>
                        </CardHeader>
                        <CardBody className="px-0 pt-0 pb-2 mx-6">
                            <div className="mt-0 mb-2 w-full">
                                <div className="mb-1 flex flex-col gap-6">
                                    <Typography variant="h6" color="blue-gray" className="-mb-3">
                                        Clave catastral
                                    </Typography>
                                    <InputMask
                                        mask="519999-999-999"
                                        value={parcelCode}
                                        onChange={(e) => setParcelCode(e.target.value)}
                                    >
                                        {(inputProps) => (
                                            <input
                                                {...inputProps}
                                                type="text"
                                                placeholder="51XXXX-XXX-XXX"
                                                className="p-2 w-full border border-gray-300 rounded"
                                            />
                                        )}
                                    </InputMask>
                                    <Typography variant="h6" color="blue-gray" className="mb-0">
                                        Descuento
                                    </Typography>
                                    <Select
                                        size='lg'
                                        label="Seleccione descuento"
                                        value={selectedDiscount}
                                        onChange={(val) => toggleDiscount(val)}
                                        labelProps={{
                                            className: "border-blue-500 focus:border-blue-500",
                                        }}
                                    >
                                        {discounts.map((discount) => (
                                            <Option key={discount.id}
                                                    value={discount.id.toString()}>{discount.percentage}%
                                                - {discount.name}</Option>
                                        ))}
                                    </Select>
                                    <Typography variant="h6" color="blue-gray" className="mb-0">
                                        Notas
                                    </Typography>
                                    <Textarea size="lg"
                                              onChange={(e) => {setNotes(e.target.value)}}
                                              rows={6}
                                              className={`mt-2 !border-blue-gray-200 focus:!border-0 focus:ring focus:ring-blue-500 focus:ring-inset`}
                                              labelProps={{
                                                  className: "!border-0 before:!border-0 after:!border-0",
                                              }}
                                    />
                                </div>
                                {error && <p className="text-red-500 text-sm mt-2">{error}</p>}
                                <Button className="mt-6" fullWidth onClick={handleSave}>
                                    Enviar
                                </Button>
                            </div>
                        </CardBody>
                    </Card>
                </div>
            </div>
        </>
    );
};

export default RegisterDiscount;